import { z } from "zod";

import type { DocumentAnswer } from "../documentAssistance/actions";
import { redactText } from "../documentAssistance/policy";

export const documentChatRequest = z.object({
  projectId: z.string().min(1),
  selections: z
    .array(
      z
        .object({
          documentId: z.string().min(1),
          start: z.number().int().positive().optional(),
          end: z.number().int().positive().optional(),
        })
        .refine(
          (value) =>
            value.start === undefined || value.end === undefined || value.end >= value.start,
          "O intervalo final deve ser maior ou igual ao inicial.",
        ),
    )
    .min(1)
    .max(3),
  consent: z.literal(true),
  mode: z.enum(["question", "consistency"]).default("question"),
});
export type DocumentChatRequest = z.infer<typeof documentChatRequest>;
function plain(value: string) {
  return redactText(value).replace(/[\\`*_{}\[\]<>#|]/g, "");
}
/** Render verified citations directly, without asking another model to rewrite them. */
export function formatDocumentAnswer(answer: DocumentAnswer) {
  return [
    ...answer.statements.map((statement) =>
      [
        plain(statement.text),
        ...statement.citations.map((citation) => {
          const source = answer.sources.find((item) => item.source === citation.source);
          return `> ${plain(citation.quote)}\n\n${citation.source}, ${source?.kind ?? "trecho"} ${citation.unit}${source ? `: ${plain(source.title)}` : ""}`;
        }),
      ].join("\n\n"),
    ),
    plain(answer.notice),
  ].join("\n\n");
}
